export default __webpack_public_path__ + "static/media/blowfish.3d1b566a.png";